'use client';
import { BonusSpinsDetails, RewardsAppProvider } from '@fanduel/rewards-hub-client';
import type { FC } from 'react';
import { useCallback, useEffect, useState } from 'react';
import { useAccountUm } from '@/hooks/use-account-um';
import { useRewardsHubConfig } from '@/hooks/use-rewards/use-rewards';
import './styles/default.scss';
import { useGlobalContext } from '@/store/contexts/global-context';
import { BonusSpinsGameTileComponent } from '@/app/components/bonus-spins-game-tiles/bonus-spins-game-tiles';
import type { RewardsPageConfig } from '@/logic/page-config/rewards/rewards-page-config';

type BonusSpinsDetailsPageClientProps = {
    pageConfig: RewardsPageConfig;
};

export const BonusSpinsDetailsPageClient: FC<BonusSpinsDetailsPageClientProps> = ({ pageConfig }) => {
    const { isLoggedIn, isMobile, isTablet, isAndroidWrapper } = useGlobalContext();
    const rewardsHubConfig = useRewardsHubConfig(pageConfig, isLoggedIn);
    const { triggerLogin } = useAccountUm();
    const [refreshKey, setRefreshKey] = useState(0);

    const handleRefresh = useCallback(() => {
        setRefreshKey((prevKey) => prevKey + 1);
    }, []);

    useEffect(() => {
        if (!isLoggedIn) {
            triggerLogin();
        }
    }, [isLoggedIn, triggerLogin]);

    if (!isLoggedIn) {
        return null;
    }

    return (
        <RewardsAppProvider>
            <BonusSpinsDetails
                key={`refreshKey${refreshKey}`}
                config={rewardsHubConfig}
                BonusSpinsGameTileComponent={BonusSpinsGameTileComponent as any}
                isMobileOrTablet={isMobile || isTablet}
                handleRefresh={handleRefresh}
                withPullToRefresh={isAndroidWrapper}
            />
        </RewardsAppProvider>
    );
};
